import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WarehouseWorkingHours } from './WarehouseWorkingHours'
/**
* Class OrderDeliveryMethodPickupDto
*  Самовывоз: снимок точки выдачи на момент оформления. Адрес здесь не дублируется — он в Domain.Entities.Orders.OrderDelivery.From; остальное покупателю нужно знать, даже если склад потом переименуют или сменят режим работы.
*/
export class OrderDeliveryMethodPickupDto extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Pickup' })
  readonly kind: string = 'Pickup'


/**
  * pointName
  * Название точки для покупателя.
  */
  @ActiveField()
  pointName?: null | string


/**
  * phone
  * Телефон точки.
  */
  @ActiveField()
  phone?: null | string


/**
  * instruction
  * Как забрать заказ.
  */
  @ActiveField()
  instruction?: null | string


  /**
  * workingHours
  * Режим работы точки.  */
  @ActiveField({
    factory: [WarehouseWorkingHours, () => undefined]
  })
  workingHours?: null | WarehouseWorkingHours
}
